const ContratosArt = ({iconContactoMasculino}) => {
   return (
      <>
         {/* <div className="bg-latitud animated fadeIn" style={{"margin-bottom": "30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Contratos ART (Jujuy y Salta)</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/> 
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Cr. Facundo Albornoz</strong><br/>
                           0388 - 154 721 718<br/>
                           0388 - 4911741 Int.: 136<br/>
                           falbornoz@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Luis Collado</strong><br/>
                        0388 - 154 711 767<br/>
                        0388 - 4911741 Int.: 132<br/>
                        lcollado@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Gabriel Correa</strong><br/>
                           0388 - 154 760 228<br/>
                           0388 - 4911741 Int.: 130<br/>
                           gcorrea@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
         <div className="section white py-5 animated fadeIn">
            {/* CABECERA DE LA SECCIÓN */}
            <div className="bg-latitud animated fadeIn mb-4" style={{ marginBottom: "30px", borderRadius: "8px", backgroundColor: "#039be5", padding: "15px" }}>
               <div className="container section center white-text" style={{ padding: "0" }}>
                  <h5 style={{ margin: 0, fontWeight: '600' }}>
                     <strong>Contratos ART (Jujuy y Salta)</strong>
                  </h5>
               </div>
            </div>

            {/* TARJETAS DE CONTACTO EN ANCHO COMPLETO */}
            <div className="row">
               <div className="col s12 m12 l6">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px' }}>
                     <div className="row valign-wrapper mb-0">
                        <div className="col s3 m2">
                           <img src={iconContactoMasculino} alt="" className="circle responsive-img"/> 
                        </div>
                        <div className="col s9 m10">
                           <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                              <strong className="light-blue-text text-darken-2" style={{ fontSize: '1.1rem' }}>Cr. Facundo Albornoz</strong><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 154 721 718</span><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 136</span><br/>
                              <a href="mailto:falbornoz@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>falbornoz@latitudsursa.com.ar</a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="col s12 m12 l6">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px' }}>
                     <div className="row valign-wrapper mb-0">
                        <div className="col s3 m2">
                           <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                        </div>
                        <div className="col s9 m10">
                           <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                              <strong className="light-blue-text text-darken-2" style={{ fontSize: '1.1rem' }}>Luis Collado</strong><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 154 711 767</span><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 132</span><br/>
                              <a href="mailto:lcollado@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>lcollado@latitudsursa.com.ar</a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="row">
               <div className="col s12 m12 l6">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px' }}>
                     <div className="row valign-wrapper mb-0">
                        <div className="col s3 m2">
                           <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                        </div>
                        <div className="col s9 m10">
                           <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                              <strong className="light-blue-text text-darken-2" style={{ fontSize: '1.1rem' }}>Gabriel Correa</strong><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 154 760 228</span><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 130</span><br/>
                              <a href="mailto:gcorrea@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>gcorrea@latitudsursa.com.ar</a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default ContratosArt